/**
 * Ruta `/perfil` (006 · T050 · US5): pestaña Perfil.
 *
 * Misma puerta que Asistencia (`useAccessGate`) con `allowSuspended: true`
 * (contracts/staff-ui.md §1): con la empresa `SUSPENDED` el perfil se sigue mostrando de solo
 * lectura (research R-12; `realms/staff.ts` exime `GET /profile`). Con el aviso de privacidad
 * pendiente se pinta su aceptación, igual que en Inicio (`GET /profile` respondería `428`).
 */
import { createFileRoute } from '@tanstack/react-router';

import { PrivacyUpdateScreen } from '../features/access/privacy-update';
import { ProfileLoading, ProfileScreen } from '../features/profile/profile-screen';
import { GateFallback } from '../features/shell/gate-fallback';
import { useAccessGate } from '../features/shell/use-access-gate';
import { t } from '../i18n';

export function PerfilGate() {
  const gate = useAccessGate({ allowSuspended: true });

  if (gate.status === 'LOADING') {
    return <ProfileLoading />;
  }
  if (gate.status === 'OFFLINE' || gate.status === 'ERROR') {
    return <GateFallback status={gate.status} retry={gate.retry} active="profile" title={t('profile.title')} />;
  }
  if (gate.status === 'PRIVACY_PENDING') {
    return <PrivacyUpdateScreen version={gate.me.privacy_notice.version} />;
  }
  return <ProfileScreen />;
}

export const Route = createFileRoute('/perfil')({
  component: PerfilGate,
});
